import {
  CreateBase,
  Form,
  useDataProvider,
  useGetIdentity,
  useNotify,
  type MutationMode,
} from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { ContactInputs } from "./ContactInputs";
import { FormToolbar } from "../layout/FormToolbar";
import {
  assertContactIsUnique,
  DuplicateRecordError,
} from "@/lib/duplicateIdentity";
import {
  cleanupContactForCreate,
  defaultEmailJsonb,
  defaultPhoneJsonb,
} from "./contactModel";

export const ContactCreate = ({
  mutationMode,
}: {
  mutationMode?: MutationMode;
}) => {
  const { identity } = useGetIdentity();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  return (
    <CreateBase
      redirect="show"
      transform={async (values) => {
        const cleaned = cleanupContactForCreate(values);
        try {
          await assertContactIsUnique(dataProvider, cleaned);
        } catch (error) {
          if (error instanceof DuplicateRecordError) {
            notify(error.message, { type: "warning" });
          }
          throw error;
        }
        return cleaned;
      }}
      mutationMode={mutationMode}
    >
      <div className="mt-2 flex lg:mr-72">
        <div className="flex-1">
          <Form
            defaultValues={{
              sales_id: identity?.id,
              email_jsonb: defaultEmailJsonb,
              phone_jsonb: defaultPhoneJsonb,
            }}
          >
            <Card>
              <CardContent>
                <ContactInputs />
                <FormToolbar />
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
